import screenfull from "screenfull";
import Boss from "../animations/bosses/Boss";
import BossDragon from "../animations/bosses/BossDragon";
import BossHobgoblin from "../animations/bosses/BossHobgoblin";
import BossMage from "../animations/bosses/BossMage";
import BossSpider from "../animations/bosses/BossSpider";
import BossSpirit from "../animations/bosses/BossSpirit";
import BossTrainingTroll from "../animations/bosses/BossTrainingTroll";
import BossTroll from "../animations/bosses/BossTroll";
import Guardian from "../animations/guardians/Guardian";
import GuardianElf from "../animations/guardians/GuardianElf";
import GuardianElfFemale from "../animations/guardians/GuardianElfFemale";
import GuardianKnight from "../animations/guardians/GuardianKnight";
import GuardianKnightFemale from "../animations/guardians/GuardianKnightFemale";
import GuardianRanger from "../animations/guardians/GuardianRanger";
import GuardianRangerFemale from "../animations/guardians/GuardianRangerFemale";
import GuardianWarrior from "../animations/guardians/GuardianWarrior";
import GuardianWitch from "../animations/guardians/GuardianWitch";
import GuardianWizard from "../animations/guardians/GuardianWizard";
import common from "../common";
import GelButton from "../ui/gel/GelButton";
import GelScene from "../ui/gel/GelScene";
import Achievement from "../Achievement";

export default class SplashScene extends GelScene {
    constructor() {
        super();

        this._bg = null;
        this._title = null;
        this._tip = null;
        this._bitesizeLogo = null;

        this._party = [];
        this._boss = null;

        this._particleLayer = null;

        this._leftFireEmitter = null;
        this._rightFireEmitter = null;
        this._leftSmokeEmitter = null;
        this._rightSmokeEmitter = null;
    }

    init() {
        super.init();
        this._bg = new PIXI.Sprite(P3.assets.texture("ui_splash"));
        this._bg.width = common.STAGE_WIDTH;
        this.addChild(this._bg);

        this._particleLayer = new PIXI.Container();
        this.addChild(this._particleLayer);

        this._leftFireEmitter = new PIXI.particles.Emitter(this._particleLayer,
            [P3.assets.texture("particle_fire_fg_flame")], P3.assets.json("particle_fire_fg_flame_00"));

        this._leftFireEmitter.updateOwnerPos(common.STAGE_WIDTH * 0.5 - 240, 472);
        this._leftFireEmitter.emit = true;

        this._leftSmokeEmitter = new PIXI.particles.Emitter(this._particleLayer,
            [P3.assets.texture("particle_fires_bg_smoke")], P3.assets.json("particle_fire_bg_smoke_00"));

        this._leftSmokeEmitter.updateOwnerPos(common.STAGE_WIDTH * 0.5 - 240, 472);
        this._leftSmokeEmitter.emit = true;

        this._rightFireEmitter = new PIXI.particles.Emitter(this._particleLayer,
            [P3.assets.texture("particle_fire_fg_flame")], P3.assets.json("particle_fire_fg_flame_00"));

        this._rightFireEmitter.updateOwnerPos(common.STAGE_WIDTH * 0.5 + 240, 472);
        this._rightFireEmitter.emit = true;

        this._rightSmokeEmitter = new PIXI.particles.Emitter(this._particleLayer,
            [P3.assets.texture("particle_fires_bg_smoke")], P3.assets.json("particle_fire_bg_smoke_00"));

        this._rightSmokeEmitter.updateOwnerPos(common.STAGE_WIDTH * 0.5 + 240, 472);
        this._rightSmokeEmitter.emit = true;

        this.initParty(common.STAGE_WIDTH * 0.5 - 340, 600);
        this.initBoss(common.STAGE_WIDTH * 0.5 + 340, 580);

        this._title = new PIXI.Sprite(P3.assets.texture("ui_logo"));
        this._title.position.set(common.STAGE_WIDTH * 0.5, 240);
        this._title.scale.set(0.9);
        this._title.anchor.set(0.5);
        this.addChild(this._title);

        this._bitesizeLogo = new PIXI.Sprite(P3.assets.texture("ui_logo_bitesize"));
        this._bitesizeLogo.anchor.set(0, 1);
        this.addChild(this._bitesizeLogo);

        this.initTipPanel();

        this.initExitButton(GelButton.TAB_INDEX_LEVEL_0);
        this.initMuteButton(GelButton.TAB_INDEX_LEVEL_0 + 1);
        this.initSettingsButton(GelButton.TAB_INDEX_LEVEL_0 + 2);
        this.initPlayButton(GelButton.TAB_INDEX_LEVEL_3);
        this.initHelpButton(GelButton.TAB_INDEX_LEVEL_3 + 1);
    }

    destroy() {
        this._leftFireEmitter.destroy();
        this._rightFireEmitter.destroy();
        this._leftSmokeEmitter.destroy();
        this._rightSmokeEmitter.destroy();

        super.destroy();
    }

    initParty(x = 0, y = 0) {
        const scale = 0.25;
        const positions = [
            new PIXI.Point(0, 0),
            new PIXI.Point(-70, -6),
            new PIXI.Point(-120, 6)
        ];

        const skins = [];
        let characters = P3.assets.json("characters");

        for (let i = 0; i < 3; ++i) {
            const position = positions[i];

            const t = P3.utils.selectRandom(characters);
            skins.push(t.skin);
            characters = characters.filter(x => skins.indexOf(x.skin) === -1);

            this._party[i] = this.createGuardian(t.type);
            this._party[i].position.set(x + position.x, y + position.y);
            this._party[i].scale.set(scale);
            this._party[i].init(t.skin);
            this.addChild(this._party[i]);

            this._party[i].setEmitterParent(this._particleLayer);
            this._party[i].playIdleAnim();
            this._party[i].update(0);
        }
    }

    initBoss(x = 0, y = 0) {
        const types = [Boss.TYPE_DRAGON, Boss.TYPE_TROLL, Boss.TYPE_HOBGOBLIN, Boss.TYPE_SPIRIT, Boss.TYPE_MAGE, Boss.TYPE_SPIDER];

        this._boss = this.createBoss(P3.utils.selectRandom(types));
        this._boss.position.set(x, y);
        this._boss.scale.set(this._boss.scale.x * 0.8, this._boss.scale.y * 0.8);
        this._boss.init();
        this.addChild(this._boss);

        this._boss.setEmitterParent(this);
        this._boss.playIdleAnim();
        this._boss.update(0);
    }

    createGuardian(type) {
        switch (type) {
            default :
            case Guardian.TYPE_ELF : {
                return new GuardianElf();
            }
            case Guardian.TYPE_ELF_FEMALE : {
                return new GuardianElfFemale();
            }
            case Guardian.TYPE_KNIGHT : {
                return new GuardianKnight();
            }
            case Guardian.TYPE_KNIGHT_FEMALE : {
                return new GuardianKnightFemale();
            }
            case Guardian.TYPE_RANGER : {
                return new GuardianRanger();
            }
            case Guardian.TYPE_RANGER_FEMALE : {
                return new GuardianRangerFemale();
            }
            case Guardian.TYPE_WARRIOR : {
                return new GuardianWarrior();
            }
            case Guardian.TYPE_WIZARD : {
                return new GuardianWizard();
            }
            case Guardian.TYPE_WITCH : {
                return new GuardianWitch();
            }
        }
    }

    createBoss(type) {
        switch (type) {
            default :
            case Boss.TYPE_DRAGON : {
                return new BossDragon();
            }
            case Boss.TYPE_SPIDER : {
                return new BossSpider();
            }
            case Boss.TYPE_HOBGOBLIN : {
                return new BossHobgoblin();
            }
            case Boss.TYPE_TROLL : {
                return new BossTroll();
            }
            case Boss.TYPE_TRAINING_TROLL : {
                return new BossTrainingTroll();
            }
            case Boss.TYPE_SPIRIT : {
                return new BossSpirit();
            }
            case Boss.TYPE_MAGE : {
                return new BossMage();
            }
        }
    }

    destroy() {
        // clean up goes here
        super.destroy();
    }

    resize() {
        super.resize();

        this._bitesizeLogo.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 50, P3.View.height - 32);
    }

    appear() {
        super.appear();

        P3.audio.playVO("vo_queen_03", 1, true);
    }

    animateIn(callback, scope) {
    }

    update() {
        const dt = window.dt;

        const settings = common.gmi.getAllSettings();
        if (settings.motion) {
            for (let i = 0; i < this._party.length; ++i)
                this._party[i].update(dt);

            this._boss.update(dt);
            this._pet && this._pet.update(dt);
        }

        this._leftFireEmitter.update(dt);
        this._rightFireEmitter.update(dt);
        this._leftSmokeEmitter.update(dt);
        this._rightSmokeEmitter.update(dt);
    }

    initTipPanel() {
        this._tip = new PIXI.Container();
        this._tip.position.set(common.STAGE_WIDTH * 0.5, P3.View.height - 28);
        this._tip.visible = false;
        this.addChild(this._tip);

        this._tip.image = new PIXI.mesh.NineSlicePlane(P3.assets.texture("answer_box_9slice"), 88, 44, 88, 44);
        this._tip.image.width = 800;
        this._tip.image.pivot.set(this._tip.image.width * 0.5, this._tip.image.height * 0.5);
        this._tip.addChild(this._tip.image);

        this._tip.label = new PIXI.extras.BitmapText("Have your brain, pencil and paper ready!", {font: "34px BBC Reith Sans"});
        this._tip.label.position.set(0, -10);
        this._tip.label.anchor.set(0.5);
        this._tip.label.tint = 0x2B365A;
        this._tip.addChild(this._tip.label);
    }

    onPlayButtonClick(button) {
        super.onPlayButtonClick(button);

        if (PIXI.utils.isMobile.android.device && screenfull.enabled) {
            screenfull.request();
        }

        common.gmi.sendStatsEvent("play", "click");
    }

    onHelpButtonClick(button) {
        super.onHelpButtonClick(button);

        // tracking
        common.gmi.sendStatsEvent("howtoplay", "click");
    }
}